module.exports = __webpack_public_path__ + "static/media/report_0001.1cdb6a8d.pdf";